/** @format */

import i18n from "i18next";
import { initReactI18next } from "react-i18next";

import en from "./locales/en.json";
import cy from "./locales/cy.json";

export type Locale = "en" | "cy";
export const localesArray: Locale[] = ["en", "cy"];

const getInitialLanguage = (): Locale => {
	const stored = localStorage.getItem("locale") as Locale | null;
	if (stored === "en" || stored === "cy") {
		return stored;
	} else {
		return "en";
	}
};

i18n.use(initReactI18next).init({
	resources: {
		en: { translation: en },
		cy: { translation: cy },
	},
	lng: getInitialLanguage(),
	fallbackLng: "en",
	ns: ["translation"],
	defaultNS: "translation",
	interpolation: {
		escapeValue: false,
	},
});

export default i18n;
